<template>
  <div class="menu-main">
    <p class="menu-main__title">{{ $t('menu.main') }}</p>

    <div class="menu-main__list">

      <router-link :to="$i18nRoute({ name: 'home' })" class="menu-main__elem">
        <IconBase icon-name="calendar">
          <IconCalendar/>
        </IconBase>
        <span>{{ $t('menu.exhibition-events') }}</span>
      </router-link>

      <router-link :to="$i18nRoute({ name: 'EventList' })" class="menu-main__elem">
        <IconBase icon-name="IconMyEvents">
          <IconMyEvents/>
        </IconBase>
        <span>{{ $t('menu.my-events') }}</span>
      </router-link>

      <router-link :to="$i18nRoute({ name: 'profile' })" class="menu-main__elem">
        <IconBase icon-name="IconAbout">
          <IconProfile/>
        </IconBase>
        <span>{{ $t('menu.profile') }}</span>
      </router-link>

    </div>
  </div>
</template>

<script>
import IconBase from '@/components/Global/DynamicIcons/IconBase'
import IconCalendar from '@/components/Global/DynamicIcons/icons/calendar'
import IconMyEvents from '@/components/Global/DynamicIcons/icons/box'
import IconProfile from '@/components/Global/DynamicIcons/icons/profile'
import { Trans } from '@/plugins/Translation'

export default {

  name: 'MainMenu',

  components: {
    IconBase,
    IconCalendar,
    IconMyEvents,
    IconProfile,
  },

}
</script>


<style lang="scss" scoped>

</style>
